import React, { useState, useEffect } from "react";
import { List, Typography, Divider, Menu, Dropdown, Button, message, Spin, Drawer, theme } from "antd";
import { MoreOutlined } from '@ant-design/icons';
import axios from "axios";
import FoodSearch from "./FoodSearch"; // adjust path if needed

const { Title } = Typography;


const TrackFoodDashboard = ({onNewItemTrackedProp}) => {
  const [data, setData] = useState([]); // DateTrack[]
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();


const calculateCalories = (trackInfo) => {
  const { foodTrack, food } = trackInfo;
  const quantity = Number(foodTrack.quantity);
  if (isNaN(quantity) || quantity <= 0) return 0;


  const calPer100g = food.calories ?? 0;
  let gramsEquivalent = 0;

  switch (foodTrack.quantityType) {
    case "grams":
      gramsEquivalent = quantity / 100;
      break;
    case "ml":
      gramsEquivalent = quantity / 100 * (food.mlpergcf || 1);
      break;
    case "item":
      gramsEquivalent = quantity * (food.onepergcf || 1);
      break;
    case "cup":
      gramsEquivalent = quantity / 100 * 250 * (food.mlpergcf || 1); // 250ml per cup assumption
      break;
    case "tbsp":
      gramsEquivalent = quantity / 100 * 15 * (food.mlpergcf || 1);  // 15ml per tbsp
      break;
    case "tsp":
      gramsEquivalent = quantity / 100 * 5 * (food.mlpergcf || 1);   // 5ml per tsp
      break;
    default:
      gramsEquivalent = quantity; // fallback
  }

  const calories = (gramsEquivalent * calPer100g);
  return Math.round(calories);
};


  // Fetch data reused in effect and onNewItemTracked
  const fetchTrackFood = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/track-foods`, { withCredentials: true });
      setData(response.data);
    } catch (err) {
      message.error("Failed to load tracked foods.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrackFood();
  }, []);

  // This is called by FoodSearch when a new item is tracked
  const onNewItemTracked = () => {
    fetchTrackFood();
   // setDrawerOpen(false);
    if (onNewItemTrackedProp) {
      onNewItemTrackedProp();
    }
  };

  

  const onMenuClick = (trackInfo, action) => {
    message.info(`${action} clicked for ${trackInfo.food.name ?? trackInfo.foodTrack.id}`);
    console.log(action);
    console.log(trackInfo);
    deleteFoodTrack(trackInfo.foodTrack.id);
  };

    const deleteFoodTrack = async (foodTrackID) => {
      setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/track-foods/${foodTrackID}`, {
        method: 'DELETE',
        credentials: 'include', // needed for CookieAuthMiddleware
      });
      if (response.status === 204) {
        messageApi.success('Food track item deleted!');
        onNewItemTracked();
      } else {
        messageApi.error(`Failed to delete: ${response.status}`);
      }
    } catch {
      messageApi.error('Error while deleting item');
    } finally {
      setLoading(false);
    }
  };

  const renderMenu = (trackInfo) => (
    <Menu
      onClick={({ key }) => onMenuClick(trackInfo, key)}
      items={[
        { key: "delete", label: "Delete" },
      ]}
    />
  );

   const {
    token: { colorPrimary },
  } = theme.useToken();


  return (
    <>
    {contextHolder}
    <div
      style={{
        width: "100%",
        maxWidth: 1200,
        height: "80vh",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #f0f0f0",
        borderRadius: 8,
        overflowY: "auto",
        padding: 16,
        boxSizing: "border-box",
        margin: "0 auto",
        maxWidth: "100%",
        '@media (min-width: 768px)': {
          width: "33vw",
          height: "80vh",
        },
      }}
    >
      {/* Sticky header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "#fff",
          zIndex: 10,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: 12,
          marginBottom: 24,
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          Today's Consumations
        </Title>
        <Button type="primary" onClick={() => setDrawerOpen(true)}>
          Track
        </Button>
      </div>

      {loading ? (
        <Spin size="large" style={{ display: "block", margin: "40px auto" }} />
      ) : data.length === 0 ? (
        <Typography.Text>No tracked food items to display</Typography.Text>
      ) : (
        data.map((dateTrack) => (
          <div key={dateTrack.trackdate} style={{ marginBottom: 24 }}>
            <Divider orientation="left">{dateTrack.trackdate}</Divider>

            {dateTrack.trackHirerarchy
              .filter(periodGroup => periodGroup.tracks.length > 0) // Show only if tracks exist
              .map(periodGroup => (
                <div key={periodGroup.period.id} style={{ marginBottom: 16 }}>
    
<Typography.Title level={5} style={{ marginBottom: 8, color: colorPrimary }}>
  {periodGroup.period.name}
</Typography.Title>
  

                  <List
                    itemLayout="horizontal"
                    dataSource={periodGroup.tracks}
                    renderItem={trackInfo => (
                      <List.Item
                        key={trackInfo.foodTrack.id}
                        style={{ paddingRight: 5 }}
                        actions={[
                          <Dropdown overlay={renderMenu(trackInfo)} trigger={['click']} placement="bottomRight" key="menu">
                            <MoreOutlined style={{ fontSize: 20, cursor: 'pointer' }} />
                          </Dropdown>,
                        ]}
                      >
                        <List.Item.Meta
                          title={trackInfo.food.name}
                         description={`${trackInfo.foodTrack.quantity} ${trackInfo.foodTrack.quantityType} • ${calculateCalories(trackInfo)} kcal`}

                        />
                      </List.Item>
                    )}
                  />
                </div>
              ))}
          </div>
        ))
      )}

      <Drawer
        title="Track Food"
        placement="bottom"
        height="90vh"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        destroyOnClose
        closable={true}
      >
        <FoodSearch onNewItemTracked={onNewItemTracked} />
      </Drawer>
    </div>
  </>
  );
  
};

export default TrackFoodDashboard;
